import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/models/entities/audit';

@Component({
    selector: 'app-audit-summary',
    templateUrl: './audit-summary.component.html',
    styleUrls: ['./audit-summary.component.scss'],
})
export class AuditSummaryComponent implements OnInit
{

    @Input() audit: Audit;

    constructor() {
    }

    ngOnInit(): void {
    }

}
